<template>
  <div class="logo-svg">
    <svg
      ref="logo"
      :class="[loaded ? '' : 'stay']"
      @mouseover="smile"
      @mouseleave="smileNone"
      @click="wink"
      viewBox="0 0 18272 18519"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xml:space="preserve"
      xmlns:serif="http://www.serif.com/"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-miterlimit:10;"
    >
      <!-- Lamp group -->
      <g ref="lamp" class="lamp">
        <path
          d="M7197.6,5792.63c94.761,68.804 225.709,170.609 225.709,282.643l-0,5.983c-0,356.561 39.757,513.949 423.144,513.949l732.71,0c383.484,0 448.041,-157.388 448.041,-513.949l0,-5.983c0,-112.034 130.948,-213.839 225.806,-282.643c207.374,-150.633 267.107,-253.018 267.107,-516.072l-0,-1248.2c-0,-355.692 -168.004,-502.755 -549.364,-502.755l-1490.9,-0c-381.361,-0 -549.364,147.063 -549.364,502.755l-0,1248.2c-0,263.054 59.732,365.439 267.107,516.072"
          style="fill:#0065b1;fill-rule:nonzero;"
        />
        <path
          d="M8421,6102.81l-0,-1413.21c-0,-40.047 32.423,-72.374 72.374,-72.374l146.58,0c39.95,0 72.374,32.327 72.374,72.374l-0,160.283c-0,39.95 -32.424,72.374 -72.374,72.374l-818.111,-0c-40.047,-0 -72.374,-32.424 -72.374,-72.374l0,-160.283c0,-40.047 32.327,-72.374 72.374,-72.374l156.424,0c39.95,0 72.373,32.327 72.373,72.374l0,1413.21"
          style="fill:none;fill-rule:nonzero;stroke:#15e8ff;stroke-width:72.37px;"
        />
        <path
          d="M9041.99,6007.75c-7.987,20.621 -15.768,41.239 -14.822,75.908c0,-0 -754.279,177.199 -1604.34,-10.063c-0,-0 2.918,-31.938 -20.5,-78.202c-0,0 724.625,184.189 1639.66,12.357Z"
          style="fill:#15e8ff;"
        />
        <path
          d="M9025.21,6178.86c-0.634,13.575 -2.172,43.584 -5.757,76.483c0,0 -741.293,176.809 -1591.35,-10.453c0,0 -2.369,-30.051 -3.8,-78.201c-0,0 685.874,184.099 1600.91,12.171Z"
          style="fill:#15e8ff;"
        />
        <path
          d="M9002.81,6349.87c-2.354,10.638 -13.885,49.478 -26.418,73.899c-0,0 -689.748,172.275 -1515.35,-9.602c-0,0 -11.166,-24.613 -21.104,-76.064c-0,-0 674.102,178.676 1562.87,11.767Z"
          style="fill:#15e8ff;"
        />
      </g>

      <!-- F short -->
      <path
        ref="fShort"
        class="f-short"
        d="M7729.87,8265.78c0,-177.929 -144.458,-322.387 -322.387,-322.387l-3698.84,-0.001c-177.929,0.001 -322.388,144.459 -322.388,322.388l0,1528.56c0,177.933 144.459,322.387 322.388,322.387l3698.84,0c177.929,0 322.387,-144.454 322.387,-322.387l0,-1528.56Z"
        style="fill:url(#_Linear2);"
      />

      <!-- F long -->
      <path
        ref="fLong"
        class="f-long"
        d="M8993.32,2173.7c186.325,0 337.571,-150.104 337.571,-334.983l0,-1503.73c0,-184.879 -151.246,-334.983 -337.571,-334.983l-8655.75,0c-186.308,0 -337.571,150.104 -337.571,334.983l0,1503.73c0,184.879 151.263,334.983 337.571,334.983l8655.75,0Z"
        style="fill:url(#_Linear1);"
      />

      <!-- i body -->
      <path
        ref="iBody"
        class="i-body"
        d="M9320.28,8278.23c0,-184.895 -150.104,-335 -335,-335l-1503.72,-0c-184.879,-0 -334.983,150.105 -334.983,335l0,9905.79c0,184.879 150.104,334.983 334.983,334.983l1503.72,0c184.896,0 335,-150.104 335,-334.983l0,-9905.79Z"
        style="fill:#0065b1;"
      />

      <!-- D body -->
      <path
        ref="dBody"
        class="d-body"
        d="M9010.87,18519c5289.33,0 9478.17,-4378.25 9251.54,-9662.83c-211.3,-4926.5 -4272.12,-8855.71 -9250.67,-8855.71l-0,2172.88c3886.15,0 7036.54,3150.33 7036.54,7036.54c-0,3754.18 -2940.18,6821.75 -6643.42,7025.62c-213.042,11.716 -391.979,11.696 -393.092,10.583l-0.866,2272.9l-0.042,0.004l0.01,0.013Z"
        style="fill:url(#_Linear3);fill-rule:nonzero;"
      />

      <!-- gradients -->
      <defs>
        <linearGradient
          id="_Linear1"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(9330.89,0,0,9330.89,0.004,1086.85)"
        >
          <stop offset="0" style="stop-color:#64cbe6;stop-opacity:1" />
          <stop offset="0.96" style="stop-color:#1166b1;stop-opacity:1" />
          <stop offset="0.99" style="stop-color:#1166b1;stop-opacity:1" />
          <stop offset="0.99" style="stop-color:#1166b1;stop-opacity:1" />
          <stop offset="1" style="stop-color:#1166b1;stop-opacity:1" />
        </linearGradient>
        <linearGradient
          id="_Linear2"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(4343.61,0,0,4343.61,3386.25,9030.06)"
        >
          <stop offset="0" style="stop-color:#4fb2d9;stop-opacity:1" />
          <stop offset="0.82" style="stop-color:#0065b1;stop-opacity:1" />
          <stop offset="1" style="stop-color:#1166b1;stop-opacity:1" />
        </linearGradient>
        <linearGradient
          id="_Linear3"
          x1="0"
          y1="0"
          x2="1"
          y2="0"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(18518.4,0,0,18518.4,-247.509,9259.65)"
        >
          <stop offset="0" style="stop-color:#15e8ff;stop-opacity:1" />
          <stop offset="0.1" style="stop-color:#15e8ff;stop-opacity:1" />
          <stop offset="0.5" style="stop-color:#0065b1;stop-opacity:1" />
          <stop offset="1" style="stop-color:#012e5c;stop-opacity:1" />
          <stop offset="1" style="stop-color:#0a0063;stop-opacity:1" />
        </linearGradient>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Logo",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    const mediaScreenDesktop = window.matchMedia("(min-width: 1100px)");
    if (mediaScreenDesktop.matches) {
      // Animation on scroll
      // Get refs
      let logo = this.$refs.logo;
      let fLong = this.$refs.fLong;
      let fShort = this.$refs.fShort;
      let lamp = this.$refs.lamp;
      let iBody = this.$refs.iBody;
      let dBody = this.$refs.dBody;

      document.addEventListener("scroll", function() {
        let setScroll = (dBody.innerHTML = window.scrollY / 5);
        if (setScroll <= 105) {
          fLong.style.transform =
            "translate(" +
            setScroll / 3 +
            "%," +
            (setScroll / 3) * 0.03 +
            "%)" +
            "rotate(" +
            setScroll / 3 +
            "deg)";
          fShort.style.transform =
            "translate(" +
            setScroll / 3 +
            "%," +
            setScroll / 3 +
            "%)" +
            "rotate(" +
            setScroll / 3 +
            "deg)";
          lamp.style.transform =
            "translate(" +
            setScroll / 3 +
            "%," +
            setScroll / 3 +
            "%)" +
            "rotate(" +
            setScroll / 3 +
            "deg)";
          iBody.style.transform =
            "translate(" +
            setScroll / 3 +
            "%," +
            setScroll / 3 +
            "%)" +
            "rotate(" +
            setScroll / 3 +
            "deg)";
          dBody.style.transform =
            "translate(" +
            (setScroll / 3) * 0.003 +
            "%," +
            (setScroll / 3) * 0.003 +
            "%)" +
            "rotate(" +
            setScroll / 3 +
            "deg)";
        } else {
          fShort.style.transform = "translate(73.5%, 13.2%)" + "rotate(90deg)";
          fLong.style.transform = "translate(30%, -0.5%)" + "rotate(90deg)";
          lamp.style.transform = "translate(4%, 27%)" + "rotate(0)";
          iBody.style.transform = "translate(30%, -43%)" + "rotate(0)";
          dBody.style.transform = "translate(100%, 0%)" + "rotate(90deg)";
        }
        if (window.scrollY > window.innerHeight * 1.2) {
          logo.style.opacity = "0";
          logo.style.transform = "scale(0)";
          logo.style.transition = "opacity 200ms ease, transform 200ms linear";
        } else {
          logo.style.opacity = "1";
          logo.style.transform = "scale(1,1)";
        }
      });
    }
    setTimeout(() => {
      this.fadeIn();
    }, 1000);
  },
  methods: {
    fadeIn() {
      this.loaded = !this.loaded;
    },
    // Smile on hover
    smile() {
      if (
        this.loaded === true &&
        window.matchMedia("(max-width: 1100px)").matches
      ) {
        this.$refs.logo.classList.add("smile");
        this.$refs.fShort.style.transform =
          "translate(73.5%, 13.2%) rotate(90deg)";
        this.$refs.fLong.style.transform =
          "translate(30%, -0.5%)" + "rotate(90deg)";
        this.$refs.lamp.style.transform = "translate(4%, 27%)" + "rotate(0)";
        this.$refs.iBody.style.transform = "translate(30%, -43%)" + "rotate(0)";
        this.$refs.dBody.style.transform =
          "translate(100%, 0%)" + "rotate(90deg)";
      }
    },
    // wink up
    wink() {
      if (window.matchMedia("(max-width: 1100px)").matches) {
        this.$refs.iBody.style.transform =
          "translate(30%, 15%)" + "scaleY(16%)";
      }
    },
    // return to logo
    smileNone() {
      if (window.matchMedia("(max-width: 1100px)").matches) {
        this.$refs.logo.classList.add("smile");
        this.$refs.fShort.style.transform = "translate(0, 0)" + "rotate(0)";
        this.$refs.fLong.style.transform = "translate(0, 0)" + "rotate(0)";
        this.$refs.lamp.style.transform = "translate(0, 0)" + "rotate(0)";
        this.$refs.iBody.style.transform = "translate(0, 0)" + "rotate(0)";
        this.$refs.dBody.style.transform = "translate(0, 0)" + "rotate(0)";
      }
    }
  },
  destroy() {
    window.removeEventListener("scroll");
  }
};
</script>

<style lang="scss">
.logo-svg {
  @include d-flex("center");
  svg {
    max-width: 300px;
    width: 55%;
    position: absolute;
    overflow: visible;
    transition: transform 350ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
    transform: translateY(-25%);
    path {
      transition: transform 350ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
    }
    &.stay {
      transform: translateY(50px);
    }
  }
  .lamp,
  .f-long,
  .f-short,
  .i-body,
  .d-body {
    transform: translate(0 0) rotate(0);
    transition: transform 0.85s;
  }
}

@media screen and (min-width: 768px) {
  .logo-svg {
    svg {
      // width: 350px;
      transform: translateY(0);
      &.stay {
        transform: translateX(-68%);
      }
    }
  }
}

@media screen and (min-width: 1100px) {
  .logo-svg {
    svg {
      position: fixed;
      max-width: 400px;
      width: 60%;
      transform: translateY(0);
      z-index: 2;
      &.stay {
        transform: translateX(-68%);
      }
    }
  }
}
</style>
